import React, { useEffect, useLayoutEffect, useState } from "react";
import { StylesProvider, createGenerateClassName, ThemeProvider } from "@material-ui/styles";
import { Backdrop, CssBaseline } from '@material-ui/core';
// import { Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import i18n from "i18next";
import Theme from "ui/Theme";
import { initDatadog } from "services/datadog";
import { verifyAccessToken } from "helpers/verifyAccessToken";

/* css */
import './assets/css/ReactToastify.scss';

/* Import Components */
import Main from "./Main";
import QchoiceLanguage from "./assets/locales";

const generateClassName = createGenerateClassName({
  seed: "qChoice",
});

function App() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    (async () => {
      const isValidAccessToken = await verifyAccessToken();
      setIsReady(isValidAccessToken);
    })();
  }, [])

  useLayoutEffect(() => {
    i18n.addResourceBundle("en-US", "qchoice", QchoiceLanguage["en-US"]);
    i18n.addResourceBundle("es-CO", "qchoice", QchoiceLanguage["es-CO"]);
    i18n.addResourceBundle("id-ID", "qchoice", QchoiceLanguage["id-ID"]);
    i18n.addResourceBundle("ja-JP", "qchoice", QchoiceLanguage["ja-JP"]);
    i18n.addResourceBundle("ko-KR", "qchoice", QchoiceLanguage["ko-KR"]);
    i18n.addResourceBundle("ms-MY", "qchoice", QchoiceLanguage["ms-MY"]);
    i18n.addResourceBundle("th-TH", "qchoice", QchoiceLanguage["th-TH"]);
    i18n.addResourceBundle("vi-VN", "qchoice", QchoiceLanguage["vi-VN"]);
    i18n.addResourceBundle("zh-CHS", "qchoice", QchoiceLanguage["zh-CHS"]);
    i18n.addResourceBundle("zh-CHT", "qchoice", QchoiceLanguage["zh-CHT"]);

    initDatadog();
  }, []);

  if (!isReady) return <Backdrop open={true} />
  
  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={Theme.lightTheme}>
        <CssBaseline/>
        <Main />
        <ToastContainer />
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
